export const vectorIcons = [ 'Home', 'cloud-conversion', 'Location', 'Sale', 'Seal', 'Search', 'Share', 'Shipping', 'Star', 'Support' ];

export const colorPalette = ['#3B93A5','#F7B844','#ADD8C7','#EC3C65','#CDD7B6','#C1F666','#D43F97','#1E5D8C','#421243','#7F94B0','#EF6537','#C0ADDB'];
/*    
export const getDriveUri = (imageUri) => {
    // Original Format: https://drive.google.com/file/d/1xKmbru4HUhQpLl974qYcAMcylrjZjeGo/view?usp=drive_link
    // Target Format:   https://drive.google.com/uc?export=view&id=1xKmbru4HUhQpLl974qYcAMcylrjZjeGo

    const fileIds = imageUri && imageUri.match(/\/d\/(.*?)\//); 
    const fileId = (fileIds && (fileIds.length > 0)) ? fileIds[1] : '';

    // return `https://drive.google.com/uc?export=view&id=${fileId}`;
    return (fileId === '') ? '/404.png' : `https://allteam-media.netlify.app/.netlify/functions/proxy/${fileId}`;

    // return imageUri && imageUri.replace('drive.google.com/file', 'lh3.googleusercontent.com').replace('/view?usp=drive_link', '');
    // return imageUri && imageUri.replace('/file/d/', '/thumbnail?id=').replace('/view?usp=drive_link', '&sz=w1000');
    // return imageUri && imageUri.replace('drive.google.com/file/d/', 'drive.usercontent.google.com/download?id=').replace('/view?usp=drive_link', '');
}
*/
export const handleImageError = (e) => {
    e.target.src = '/404.png';
};
